import React from "react";
import Reports from "../modules/Reports/Reports";

export default function ReportsPage() {
  return <Reports />;
}
